// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editClient{
    background-color: #fff;
    width: 100%;
    height: 100%;
    padding-top: 46px;
    padding-left: 30px;
    padding-right: 56px;
    padding-bottom: 30px;
    overflow: auto;
}

.editClient_title{
    font-weight: 700;
    font-size: calc(24px * var(--fontScaler));
    line-height: 33px;
    color: #000000;

    padding-bottom: 35px;
}

.editClient_head_text{
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 16px;
    color: #000000;

    padding-bottom: 28px;
}

.editClient_form{
    display: flex;
    flex-wrap: wrap;
    --formGap: 10px;
    gap: 0px var(--formGap);
}

.editClient_schedule{
    width: 100%;
}

.editClient_schedule_label{
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 150%;

    color: #3B4256;
    margin-bottom: 16px;
}

.editClient_schedule_content{
    display: flex;
    gap: 21px;
}

.editClient_firstName{
    width: calc(40% - var(--formGap) / 2);
}

.editClient_lastName{
    width: calc(60% - var(--formGap) / 2);
}

.editClient_dateOfBirth{
    width: calc(65% - var(--formGap) / 2);
}

.editClient_email{
    width: calc(35% - var(--formGap) / 2);
}

.editClient_notes{
    width: 100%;
    margin-top: 10px;
}

.editClient_buttons{
    display: flex;
    width: 100%;
    gap: 10px;
}

.editClient_submit{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFA825;
    border-radius: 24px;
    height: 40px;
    width: 100%;
    max-width: 217px;
    margin-top: 84px;

    font-weight: 500;
    font-size: calc(13px * var(--fontScaler));
    line-height: 23px;
    text-align: center;
    text-transform: uppercase;
    color: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/editClient/EditClient.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;;IAEd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;;IAEd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;;IAEhB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".editClient{\n    background-color: #fff;\n    width: 100%;\n    height: 100%;\n    padding-top: 46px;\n    padding-left: 30px;\n    padding-right: 56px;\n    padding-bottom: 30px;\n    overflow: auto;\n}\n\n.editClient_title{\n    font-weight: 700;\n    font-size: calc(24px * var(--fontScaler));\n    line-height: 33px;\n    color: #000000;\n\n    padding-bottom: 35px;\n}\n\n.editClient_head_text{\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 16px;\n    color: #000000;\n\n    padding-bottom: 28px;\n}\n\n.editClient_form{\n    display: flex;\n    flex-wrap: wrap;\n    --formGap: 10px;\n    gap: 0px var(--formGap);\n}\n\n.editClient_schedule{\n    width: 100%;\n}\n\n.editClient_schedule_label{\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 150%;\n\n    color: #3B4256;\n    margin-bottom: 16px;\n}\n\n.editClient_schedule_content{\n    display: flex;\n    gap: 21px;\n}\n\n.editClient_firstName{\n    width: calc(40% - var(--formGap) / 2);\n}\n\n.editClient_lastName{\n    width: calc(60% - var(--formGap) / 2);\n}\n\n.editClient_dateOfBirth{\n    width: calc(65% - var(--formGap) / 2);\n}\n\n.editClient_email{\n    width: calc(35% - var(--formGap) / 2);\n}\n\n.editClient_notes{\n    width: 100%;\n    margin-top: 10px;\n}\n\n.editClient_buttons{\n    display: flex;\n    width: 100%;\n    gap: 10px;\n}\n\n.editClient_submit{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #FFA825;\n    border-radius: 24px;\n    height: 40px;\n    width: 100%;\n    max-width: 217px;\n    margin-top: 84px;\n\n    font-weight: 500;\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 23px;\n    text-align: center;\n    text-transform: uppercase;\n    color: #FFFFFF;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
